import React, {MouseEventHandler, useState} from 'react'
import {CircularProgress, Flex, FlexProps} from '@chakra-ui/react'
import {useTranslation} from 'next-i18next'
import Script from 'next/script'
import {useRouter} from '_app/hooks/useRouter'
import Button from '_app/components/Buttons/Button'
import {APP_ROUTES} from '_app/routes'
import {ApplePay} from 'modules/applePay/ApplePay'

type Props = FlexProps & { isDisabled?: boolean };

export const CartFooter = ({isDisabled, ...flexProps}: Props) => {
    const {t} = useTranslation('cart')
    const { locale } = useRouter()
    const [loading, setLoading] = useState(false)
    const showApplePayButton = process.env.NEXT_PUBLIC_APPLE_PAY_ENABLED === '1' && typeof window !== 'undefined' && window.ApplePaySession?.canMakePayments()
    const checkoutHandler: MouseEventHandler<HTMLButtonElement> = () => {
        setLoading(true)
        window?.open(`/${locale}${APP_ROUTES.CHECKOUT}.html`, '_self')
    }
    return (
        <>
            <Script
                id="autocompleteCheckout"
                src="https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js"
            />

            <Flex
                flexDirection={{base: 'column-reverse', md: 'row'}}
                width="100%"
                bgColor="#fff"
                border="solid 1px #ede7e1"
                borderTop={{base: 'none', lg: 'solid 1px #ede7e1'}}
                p={{base: 4, md: 6}}
                gap={{base: 'unset', md: 8}}
                justifyContent={{base: 'flex-end', md: 'space-between'}}
                {...flexProps}
            >
                {showApplePayButton && <ApplePay/>}
                <Button
                    onClick={checkoutHandler}
                    width={{base: 'full', md: '19rem'}}
                    marginLeft="auto"
                    isDisabled={isDisabled}
                >
                    {t('GO_TO_CHECKOUT')}
                    {
                        loading && (
                            <CircularProgress sx={{marginLeft: '20px', transform: 'scale(.7)'}} isIndeterminate/>
                        )
                    }
                </Button>
            </Flex>
        </>
    )
}
